exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".info-policy[data-v-16c26e9e]{font-size:12px}.card-under[data-v-16c26e9e]{font-size:20px}", ""]);
